import type { FC } from 'react';
import React from 'react';
import { Flex, Body, Box } from '@edreamsodigeo/prisma-design-system';
import { createFeature } from '@edreamsodigeo/frontend-core';

import type {
  LocationTitleProps,
  SectionLocationMapItineraryProps,
} from '@/components/FlightSummary/MapItinerary/types';
import { LocationType } from '@/generated/graphql';
import { RAILS_STATION_NAMES_WITHOUT_IATA } from '@/versionedComponents';

const LocationTitle: FC<LocationTitleProps> = ({ iata, nameAndTerminal }) => (
  <>{`${iata} (${nameAndTerminal})`}</>
);

const LocationTitleWithTrainSupport: FC<LocationTitleProps> = ({
  locationType,
  iata,
  nameAndTerminal,
}) =>
  locationType === LocationType.TrainStation ? (
    <>{nameAndTerminal}</>
  ) : (
    <LocationTitle iata={iata} nameAndTerminal={nameAndTerminal} />
  );

const LocationTitleVersioned = createFeature({
  name: RAILS_STATION_NAMES_WITHOUT_IATA,
  variations: [LocationTitle, LocationTitleWithTrainSupport],
  version: 1,
});

const SectionLocationMapItinerary: FC<SectionLocationMapItineraryProps> = ({
  name,
  cityName,
  countryName,
  iata,
  terminal,
  locationType,
}) => {
  const nameAndTerminal =
    name + (terminal && terminal.trim() !== '' ? `, T${terminal}` : '');
  return (
    <>
      <Flex flexDirection="column" mb="big">
        <Body type="base" weight="medium">
          <LocationTitleVersioned
            locationType={locationType}
            iata={iata}
            nameAndTerminal={nameAndTerminal}
          />
        </Body>
        <Box>
          <Body type="base" weight="normal" color="neutral.80">
            {`${cityName} (${countryName})`}
          </Body>
        </Box>
      </Flex>
    </>
  );
};

export default SectionLocationMapItinerary;
